/* ============================= E X P O R T ============================= */

export default {
  name: 'PencilSquare',

  props: {
    color: {
      type: String,
      in: [
        'primary',
        'secundary'
      ]
    }
  }
}
